<template>
    <v-card>
        <v-card-text class="text-center headline secondary--text">
            Desculpe, mas ocorreu um erro...
            <div class="grey--text text--darken-2 subtitle-1 pt-2">
                Essa página só pode ser acessada através de um link enviado ao seu e-mail
            </div>
        </v-card-text>
        <v-img :src="require('@/assets/cabeca_pit.png')" max-width="200px"></v-img>
    </v-card>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>
